import { render, staticRenderFns } from "./TrafficOffer.vue?vue&type=template&id=b1b7a622&scoped=true"
import script from "./TrafficOffer.vue?vue&type=script&lang=js"
export * from "./TrafficOffer.vue?vue&type=script&lang=js"
import style0 from "./TrafficOffer.vue?vue&type=style&index=0&id=b1b7a622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b7a622",
  null
  
)

export default component.exports